import React from "react";
import { NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./StuStyles/StudentSidebar.css";

import {
  FaHome,
  FaBriefcase,
  FaChartBar,
  FaChalkboardTeacher,
  FaCalendarAlt,
  FaUsers,
  FaUserCheck,
  FaEdit,
  FaFileAlt,
  FaCloudUploadAlt,
  FaBell,
} from "react-icons/fa";

const StudentSidebar = ({ profileCompletion = 70 }) => {
  const menuItems = [
    { icon: <FaHome />, label: "Dashboard", path: "/student/", end: true },
    { icon: <FaBriefcase />, label: "Jobs", path: "/student/Jobs" },
    { icon: <FaChartBar />, label: "Application Tracker", path: "/student/JobStrategy" },
    { icon: <FaChalkboardTeacher />, label: "Training Program", path: "/student/TrainingPrograms" },
    { icon: <FaCalendarAlt />, label: "Events", path: "/student/LiveEvents" },
    { icon: <FaUsers />, label: "Job Fairs", path: "/student/Jobfairs" },
  ];

  const radius = 30;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (profileCompletion / 100) * circumference;

  return (
    <div className="sidebar d-flex flex-column p-3">
      <ul className="nav flex-column mb-4">
        {menuItems.map((item, idx) => (
          <li key={idx} className="nav-item mb-1">
            <NavLink
              to={item.path}
              end={item.end}
              className={({ isActive }) =>
                "nav-link sidebar-link d-flex align-items-center " +
                (isActive ? "active-link" : "")
              }
            >
              <span className="sidebar-ico me-2">{item.icon}</span>
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="card sidebar-card text-center mb-3 p-3">
        <h6 className="fw-bold mb-3 card-title-icon">
          <FaUserCheck className="card-title-ico" />
          Complete Your Profile
        </h6>
        <div className="progress-circle-wrapper mx-auto mb-2">
          <svg width="80" height="80">
            <circle cx="40" cy="40" r={radius} stroke="#e6e6e6" strokeWidth="6" fill="none" />
            <circle
              cx="40"
              cy="40"
              r={radius}
              stroke="#2e7d32"
              strokeWidth="6"
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              strokeLinecap="round"
              transform="rotate(-90 40 40)"
            />
            <text x="50%" y="50%" textAnchor="middle" dy="0.35em" fontSize="16" fontWeight="bold" fill="#333">
              {profileCompletion}%
            </text>
          </svg>
        </div>
        <p className="small text-muted mb-3">Complete your profile to increase your visibility.</p>
        <button className="btn btn-navy btn-sm w-100 d-flex align-items-center justify-content-center gap-2">
          <FaEdit />
          Update Profile
        </button>
      </div>

      <div className="card sidebar-card text-center mb-3 p-3">
        <div className="upload-icon mx-auto mb-2">
          <FaFileAlt />
        </div>
        <h6 className="fw-bold mb-1">Upload Resume</h6>
        <p className="small text-muted mb-3">Upload your latest resume and get better job matches.</p>
        <button className="btn btn-outline-navy btn-sm w-100 d-flex align-items-center justify-content-center gap-2">
          <FaCloudUploadAlt />
          Upload Now
        </button>
      </div>

      <div className="d-flex align-items-center job-alerts p-2">
        <FaBell className="me-2" />
        <div>
          <div className="fw-bold small">Job Alerts</div>
          <div className="text-muted job-alert-sub">Get notified about new job opportunities</div>
        </div>
      </div>
    </div>
  );
};

export default StudentSidebar;